import React, { useContext } from 'react';
import 'twin.macro';
import { PreferenceContext } from '../context';
import { Container } from '../container';
import { UnderlinedNav } from '../sections/Header';

export const detailNavList = [
  { label: 'Reaguursels', to: null, ElementType: 'div', upDatePreference: 'comments' },
  { label: 'Zie ook', to: null, ElementType: 'div', upDatePreference: 'items' },
];

export const ItemMobileSelector = () => {
  const {
    preference: { detailsPageMobileBlock },
  } = useContext(PreferenceContext);

  return (
    <div tw='relative min-w-[340px] w-full pb-6 bottom-0 z-10 bg-primary adsbreak-l:hidden'>
      <Container noSpacing tw='border-input-back border-b-[4px]'>
        <UnderlinedNav
          itemsList={detailNavList}
          navLocation={'itemDetail'}
          selectedItem={detailsPageMobileBlock}
          tw='pb-2'
        />
      </Container>
    </div>
  );
};
